import { useT } from "@/i18n";
import { IconHistory } from "@/ui";

import { GlobalSearchItem } from "../GlobalSearch.types";

import { ClubSearchItemView } from "./ClubSearchItemView";
import { LeagueContextSearchItemView } from "./LeagueContextSearchItemView";
import { LeagueSearchItemView } from "./LeagueSearchItemView";
import { LicenseSearchItemView } from "./LicenseSearchItemView";
import { OrganizationSearchItemView } from "./OrganizationSearchItemView";
import { PageSearchItemView } from "./PageSearchItemView";
import { PlatformSearchItemView } from "./PlatformSearchItemView";
import { TeamSearchItemView } from "./TeamSearchItemView";
import { TournamentSearchItemView } from "./TournamentSearchItemView";
import { TransactionSearchItemView } from "./TransactionSearchItemView";
import { UserSearchItemView } from "./UserSearchItemView";

export type SearchItemViewProps = {
  item: GlobalSearchItem;
  isRecent?: boolean;
};

const renderItem = (item: GlobalSearchItem) => {
  switch (item.type) {
    case "page":
      return <PageSearchItemView item={item} />;
    case "user":
      return <UserSearchItemView item={item} />;
    case "tournament":
      return <TournamentSearchItemView item={item} />;
    case "license":
      return <LicenseSearchItemView item={item} />;
    case "club":
      return <ClubSearchItemView item={item} />;
    case "league":
      return <LeagueSearchItemView item={item} />;
    case "team":
      return <TeamSearchItemView item={item} />;
    case "transaction":
      return <TransactionSearchItemView item={item} />;
    case "organization":
      return <OrganizationSearchItemView item={item} />;
    case "platform":
      return <PlatformSearchItemView item={item} />;
    case "rankingRule":
    case "rankingCategory":
    case "tournamentCategory":
    case "rankingPointBlock":
    case "news":
    case "partner":
    case "album":
      return <LeagueContextSearchItemView item={item} />;
  }
};

export const SearchItemView = ({ item, isRecent }: SearchItemViewProps) => {
  const t = useT();
  const content = renderItem(item);

  if (!isRecent) return content;

  return (
    <div className="flex items-center gap-3 w-full">
      <IconHistory
        size="sm"
        className="shrink-0 text-content-tertiary"
        aria-label={t("general.globalSearch.recentLabel")}
      />
      <div className="flex-1 min-w-0">{content}</div>
    </div>
  );
};
